export default __webpack_public_path__ + "static/media/15.00ccf711.png";